export const Audit = {
    IbConfigSuperiorIb: 'Superior IB',
    IbConfigIbRole: 'IB Role',
    IbConfigResultRemark: 'Details',
    IbConfigApplicant: 'Applicant',
    IbConfigSystemRemark: 'System Message',
    IbConfigStatusProcessing: 'Processing',
    IbConfigStatusDone: 'Completed',
    IbConfigStatusFailed: 'Failed',
    IbConfigStatusRejected: 'Rejected',
    IbConfigStatusPendingAudit: 'Pending Submission',
    IbConfigStatusAuditing: 'Under Review',
    IbConfigStatusPending: 'Pending Execution',
    IbConfigOperatorName: 'Submitted By',
    IbConfigSubmitSource: 'Submission Source',
    IbConfigSubmitterSelf: 'This Sales',
    IbConfigSubmitterSubordinate: 'Sub Sales',
    IbConfigAccountUuid: 'Client UUID',
    IbConfigSuperiorIbUuid: 'Superior IB UUID',
    // [meegle:14347943] Ticket list tabs / account column / IB UUID search option
    IbConfigTabUpgrade: 'Upgrade IB',
    IbConfigTabRebate: 'IB Rebate Config',
    IbConfigClientAccount: 'Client Account',
    IbConfigIbAccount: 'IB Account',
    IbConfigIbUuid: 'IB UUID',
    // Empty state for an invalid / not-yours ticket detail link
    IbConfigTicketUnavailable: 'Ticket not found or not accessible',
    IbConfigBackToList: 'Back to ticket list',
    IbConfigSourceAdmin: 'BSS Admin',
    IbConfigSourceSales: 'BSS Sales',
    IbConfigBizRebate: 'IB Rebate Config',
    IbConfigBizUpgrade: 'IB Upgrade',
    IbConfigCurrentInfo: 'Current Info',
    IbConfigLinkTitle: 'Account Opening Links',
    IbConfigLinkSummary: '{total} in total, {added} new',
    IbConfigLinkName: 'Link Name',
    IbConfigLinkSource: 'Source',
    IbConfigLinkDefault: 'Default',
    IbConfigLinkNew: 'New',
    IbConfigLinkExisting: 'Existing',
    IbConfigRebateTitle: 'Rebate Strategy Details',
    IbConfigRebateCount: '{count} in total',
    IbConfigRebateAccountType: 'Account Type',
    IbConfigRebateSubType: 'Sub Type',
    IbConfigRebateColValue: 'Value / FX Value',
    IbConfigRebateColMetal: 'Precious Metal Value',
    IbConfigSymbolRuleTitle: 'Symbol Group Rebate Rules',
    IbConfigSymbolRuleCount: '{count} rules',
    IbConfigSymbolRuleEmpty: 'No symbol group rules',
    IbConfigStatsTitle: 'Configuration Stats',
    IbConfigStatsLinkTotal: 'Total Links',
    IbConfigStatsLinkNew: 'New Links',
    IbConfigStatsActiveSubType: 'Active Sub Types',
    IbConfigSummaryTitle: 'Application Summary',
    IbConfigTicketTypeLabel: 'Ticket Type',
    IbConfigTicketTypeUpgradeSub: 'Upgrade to IB',
    IbConfigTicketTypeUpgradeTop: 'Upgrade to Top-level IB',
    IbConfigTicketTypeModifyStrategy: 'Rebate Configuration',
    IbConfigTopGroup: 'Top-level Group',
    IbConfigRebateDesc:
        'Sub-types are de-duplicated across all links. MT4 STP / ECN and MT5 ECN carry a single value; the precious-metal column does not apply.',
    IbConfigSymbolRuleDesc: 'The finest-grained rules generated at submission.',
    IbConfigSubmitterRequired: 'Please select the sub sales you want to query',
    IbConfigClientId: 'Client ID',
};
